import { combineReducers, configureStore  } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from "react-redux";

import storage from "redux-persist/lib/storage";
import { persistReducer } from "redux-persist";
import { FLUSH,  REHYDRATE,  PAUSE,  PERSIST,  PURGE,  REGISTER,} from 'redux-persist'

import { authInfoSlice } from 'stores/authSlice';
import { userInfoSlice } from 'stores/userSlice';


const reducers = combineReducers({
  
  authInfo: authInfoSlice.reducer,
  userInfo: userInfoSlice.reducer,
  
});

// config 작성
const persistConfig = {
  key: "root",
  storage, // 로컬 스토리지에 저장
  whitelist: ["authInfo"],
};

const persistedReducer = persistReducer(persistConfig, reducers);

const store = configureStore({
  reducer: persistedReducer ,

  middleware : (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});


// useSelector 사용시 타입으로 사용하기 위함
export type RootState = ReturnType<typeof store.getState>

// useDispatch를 좀 더 명확하게 사용하기 위함
export type AppDispatch = typeof store.dispatch

export const useAppDispatch = () => useDispatch();
export const useAppSelector = useSelector;

export default store;
